import theme from '../theme';

const mailColor = (status: string) => {
  const mailColors: {[key: string]: string} = theme.status.mail;
  return mailColors[status];
};

export default mailColor;
